export const IMAGE_RATIO = {
	R1_1: '1x1',
	R3_2: '3x2',
};

export type ImageRatioValues = '1x1' | '3x2';
